import { BaseBenefitPlanPolicyPeriod } from "@platform/openapi-types";

/**
 * Formats the Quotes tab's synthetic "Incumbent/Requested" carrier column
 * header. `current` is the only policy period that can mean an incumbent, so
 * it's the only one that ever reads a carrier name; `newBusiness` and
 * `alternate` are both broker-drafted designs with no carrier of their own and
 * always read as a plain "Requested".
 *
 * @example
 * formatRequestedColumnLabel("VSP", BaseBenefitPlanPolicyPeriod.current) // "VSP - Current"
 * formatRequestedColumnLabel(undefined, BaseBenefitPlanPolicyPeriod.current) // "Current"
 * formatRequestedColumnLabel("VSP", BaseBenefitPlanPolicyPeriod.newBusiness) // "Requested"
 * formatRequestedColumnLabel(undefined, BaseBenefitPlanPolicyPeriod.alternate) // "Requested"
 */
export const formatRequestedColumnLabel = (
  carrierName: string | undefined,
  policyPeriod: BaseBenefitPlanPolicyPeriod | undefined,
): string => {
  if (policyPeriod !== BaseBenefitPlanPolicyPeriod.current) {
    return "Requested";
  }

  const trimmedCarrierName = carrierName?.trim();
  return trimmedCarrierName ? `${trimmedCarrierName} - Current` : "Current";
};
